import * as Config from '../../../../../config';
import React from 'react';
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

import Content from '../../../common/Content';
import GridCharts from '../../../content/grid/GridCharts';

import LinkRoute from '../../../route/LinkRoute';
import SearchRoute from '../../../route/SearchRoute';
import PlaylistRoute from '../../../route/PlaylistRoute';
import HistoryRoute from '../../../route/HistoryRoute';
import Collection from '../../../views/Collection';
import CartRoute from '../../../cart/CartRoute';

import Faq from '../../../views/Faq';

/* CUSTOM MODS */
import PartyModeRoute from '../../../partymode/PartyModeRoute';
import MyBeatport from '../mods/mybeatport/Container';
import DigDeeper from '../mods/digdeeper/Container';

function ConnectedCustomRoute({ width, height }) {
  return (
    <>
      <LinkRoute />
      <SearchRoute />
      <PlaylistRoute />
      <HistoryRoute />
      <CartRoute />
      <PartyModeRoute />
      <Switch>
        <Route path="/my-beatport">
          <MyBeatport />
        </Route>
        <Route path="/dig-deeper">
          <DigDeeper />
        </Route>
        <Route path="/collection">
          <Collection />
        </Route>
        <Route path="/featured-playlists" render={() => {
          if (document.getElementById(`cm-v2`)) {
            document.getElementById(`cm-v2`).scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
          return (
            <>
              <GridCharts title={`B-Sides`} id={`{A}beatport_b_sides_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bp/b-sides`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=B-Sides` }
                className={`grid-chart new-playlists`}
              />
              <GridCharts title={`Best of Hype`} id={`{B}beatport_hype_playlists_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bp/hype-playlists`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=Best New Hype` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Best Sellers`} id={`{C}beatport_best_sellers_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={false}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=Best Sellers` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Closing Essentials`} id={`{D}beatport_closing_essentials_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bp/closing-essentials`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=Closing essentials` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Crate Diggers`} id={`{E}beatport_crate_diggers_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bp/crate-diggers`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=Crate Diggers` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`DJ Sets`} id={`{F}beatport_djsets_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/djsets`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT + Config.CARD_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT + Config.CARD_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=60&dj_id=637514` /* artist_id 958601 */ }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Exclusive Only`} id={`{G}beatport_exclusive_only_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bp/exclusive-only`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=Exclusive`  }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Future Classics`} id={`{H}beatport_future_classics_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bp/future-classics`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=Future Classics`  }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`In the Remix`} id={`{I}beatport_in_the_remix_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bp/in-the-remix`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=In the Remix` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`NYE Essentials`} id={`{J}beatport_nye_essentials_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bp/nye-essentials`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=NYE Essentials`  }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Opening Fundamentals`} id={`{K}beatport_opening_fundamentals_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bp/opening-fundamentals`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=Opening Fundamentals`  }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Peak Hour Tracks`} id={`{L}beatport_peak_hour_tracks_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bp/peak-hour-tracks`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=Peak Hour Tracks`  }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Secret Weapons`} id={`{M}beatport_secret_weapons_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bp/secret-weapons`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=Secret Weapons` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Staff Picks`} id={`{N}beatport_staff_picks_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bp/staff-picks`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=Staff Picks` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`The Shortlists`} id={`{O}beatport_shortlists_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bp/the-shortlists`} allLabel={`View All`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&dj_id=36047&name=Shortlist`  }
                className={`grid-chart beatx`}
              />
            </>
          );
        }} />
        <Route path="/bp/djsets">
          <Content name={`DJ Sets`}>
            <GridCharts id={`djsets`} width={width}
              hasFilters={false} buttonFilterStyle={{ top: 12 }} filtersStyle={{ top: 43, height: 250 }}
              height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=637514`}
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true}
            />
          </Content>
        </Route>
        <Route path="/bp/crate-diggers">
          <Content name={`Crate Diggers`}>
            <GridCharts id={`beatport_crate_diggers_playlists`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Crate Diggers` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/tracks-you-might-have-missed">
          <Content name={`Tracks you may have missed`}>
            <GridCharts id={`beatport_tracks_you_might_have_missed`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Tracks you might have missed` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/hype-playlists">
          <Content name={`Best of Hype`}>
            <GridCharts id={`beatport_hype_playlists`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Best New Hype` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/secret-weapons">
          <Content name={`Secret Weapons`}>
            <GridCharts id={`beatport_secret_weapons_essentials`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Secret Weapons` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/closing-essentials">
          <Content name={`Closing essentials`}>
            <GridCharts id={`beatport_closing_essentials`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Closing essentials` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/best-new">
          <Content name={`Best New`}>
            <GridCharts id={`beatport_best_new`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Best New` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/exclusive-only">
          <Content name={`Exclusive Only`}>
            <GridCharts id={`beatport_exclusive_only`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Exclusive` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/staff-picks">
          <Content name={`Staff Picks`}>
            <GridCharts id={`beatport_staff_picks`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Staff Picks` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/the-shortlists">
          <Content name={`The Shortlists`}>
            <GridCharts id={`beatport_the_shortlists`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Shortlist` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/top-10">
          <Content name={`Top 10`}>
            <GridCharts id={`beatport_top_list`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Top 10` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/b-sides">
          <Content name={`B-Sides`}>
            <GridCharts id={`beatport_b_sides`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=B-Sides` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/in-the-remix">
          <Content name={`In the Remix`}>
            <GridCharts id={`beatport_in_the_remix`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=In the Remix` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/future-classics">
          <Content name={`Future Classics`}>
            <GridCharts id={`beatport_future_classics`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Future Classics` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/nye-essentials">
          <Content name={`NYE Essentials`}>
            <GridCharts id={`beatport_nye_essentials`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=NYE Essentials` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/opening-fundamentals">
          <Content name={`Opening Fundamentals`}>
            <GridCharts id={`beatport_opening_fundamentals`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Opening Fundamentals` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/peak-hour-tracks">
          <Content name={`Peak Hour Tracks`}>
            <GridCharts id={`beatport_peak_hour_tracks`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Peak Hour Tracks` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/summer-sounds">
          <Content name={`Summer Sounds`}>
            <GridCharts id={`beatport_summer_sounds`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Summer Sounds` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bp/link-artists">
          <Content name={`LINK Artists`}>
            <GridCharts id={`beatport_link_artists`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&name=LINK ARTIST` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/FAQ">
          <Faq />
        </Route>
      </Switch>
    </>
  );
}

const CustomRoute = connect(
  state => ({
    width: state.dimension.width,
    height: state.dimension.height
  })
)(ConnectedCustomRoute);

export default CustomRoute;
